import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "decks" }
const _hoisted_3 = { class: "page-filters pf-bar" }
const _hoisted_4 = { class: "pf-search" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  value: "all"
}
const _hoisted_7 = { class: "decks-tm-icon" }
const _hoisted_8 = { class: "decks-tm-main" }
const _hoisted_9 = { class: "decks-tm-name" }
const _hoisted_10 = {
  key: 0,
  class: "decks-chips"
}
const _hoisted_11 = {
  key: 0,
  class: "decks-chip overdue"
}
const _hoisted_12 = {
  key: 1,
  class: "decks-chip due"
}
const _hoisted_13 = {
  key: 2,
  class: "decks-chip"
}
const _hoisted_14 = {
  key: 3,
  class: "decks-chip"
}
const _hoisted_15 = {
  key: 0,
  class: "decks-tm-cols"
}
const _hoisted_16 = { class: "decks-tm-icon" }
const _hoisted_17 = { class: "decks-tm-main" }
const _hoisted_18 = { class: "decks-tm-name" }
const _hoisted_19 = { class: "decks-section-h" }
const _hoisted_20 = {
  key: 1,
  class: "decks-grid"
}
const _hoisted_21 = { class: "decks-tile-top" }
const _hoisted_22 = { class: "decks-tile-head" }
const _hoisted_23 = { class: "decks-tile-name" }
const _hoisted_24 = {
  key: 0,
  class: "tm-badge"
}
const _hoisted_25 = ["aria-label"]
const _hoisted_26 = { class: "decks-legend" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "decks-legend-name" }
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "decks-tile-foot" }
const _hoisted_31 = { class: "decks-chip" }
const _hoisted_32 = {
  key: 0,
  class: "decks-chip overdue"
}
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 0,
  class: "more"
}
const _hoisted_35 = ["title"]
const _hoisted_36 = {
  key: 2,
  class: "decks-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_add_company_board = _resolveComponent("add-company-board")!
  const _component_deck_folder_modal = _resolveComponent("deck-folder-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Work"),
        _createElementVNode("div", { class: "page-bar-main" }, "Decks")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              "aria-hidden": "true"
            }, [
              _createElementVNode("circle", {
                cx: "11",
                cy: "11",
                r: "7"
              }),
              _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQ) = $event)),
              placeholder: "Search decks",
              "aria-label": "Search decks",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
            }, null, 544), [
              [_vModelText, _ctx.searchQ]
            ])
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.boardFilter) = $event)),
            "aria-label": "Which decks",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterChanged()))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder) => {
              return (_openBlock(), _createElementBlock("option", {
                key: folder.ID,
                value: 'folder:' + folder.ID
              }, _toDisplayString(folder.Name), 9, _hoisted_5))
            }), 128)),
            _cache[13] || (_cache[13] = _createElementVNode("option", { value: "mine" }, "My Decks", -1)),
            (_ctx.$store.state.user.superAdmin)
              ? (_openBlock(), _createElementBlock("option", _hoisted_6, "All Decks"))
              : _createCommentVNode("", true)
          ], 544), [
            [_vModelSelect, _ctx.boardFilter]
          ]),
          (_ctx.currentFolder)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-light",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editingFolder = _ctx.currentFolder))
              }, "Edit Folder"))
            : _createCommentVNode("", true),
          (_ctx.canUseFolders)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn-light",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editingFolder = 'new'))
              }, "New Folder"))
            : _createCommentVNode("", true),
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
          (_ctx.$store.state.user.role == 'Admin' || _ctx.$store.state.user.superAdmin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn-light",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/board-templates')))
              }, "Templates"))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAddBoard = true))
          }, "Add Deck")
        ]),
        (_ctx.taskManagerLoaded && (_ctx.taskManager || _ctx.canCreateTaskManager))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.taskManager)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "decks-tm",
                    to: '/deck/' + _ctx.taskManager.Slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_svg_icon, { icon: "checklist" })
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "decks-eyebrow" }, "My Task Manager", -1)),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.taskManager.Name), 1),
                        (_ctx.myTaskManager)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              (_ctx.myTaskManager.Overdue)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.myTaskManager.Overdue) + " overdue", 1))
                                : _createCommentVNode("", true),
                              (_ctx.myTaskManager.DueThisWeek)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.myTaskManager.DueThisWeek) + " due this week", 1))
                                : _createCommentVNode("", true),
                              (_ctx.myTaskManager.InboxCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.myTaskManager.InboxCount) + " in Inbox", 1))
                                : _createCommentVNode("", true),
                              (!_ctx.myTaskManager.Overdue && !_ctx.myTaskManager.DueThisWeek && !_ctx.myTaskManager.InboxCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Nothing due this week"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.myTaskManager && (_ctx.myTaskManager.ColumnCounts || []).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myTaskManager.ColumnCounts.slice(0, 4), (col) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: col.name,
                                class: "decks-tm-col"
                              }, [
                                _createElementVNode("b", null, _toDisplayString(col.count), 1),
                                _createElementVNode("span", null, [
                                  _createElementVNode("i", {
                                    class: "decks-dot",
                                    style: _normalizeStyle({ background: col.color })
                                  }, null, 4),
                                  _createTextVNode(_toDisplayString(col.name), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _cache[16] || (_cache[16] = _createElementVNode("span", {
                        class: "decks-arrow",
                        "aria-hidden": "true"
                      }, "›", -1))
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: _normalizeClass(["decks-tm", _ctx.settingUpTaskManager ? 'busy' : '']),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setUpTaskManager()))
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_svg_icon, { icon: "checklist" })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "decks-eyebrow" }, "My Task Manager", -1)),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.settingUpTaskManager ? 'Setting up...' : 'Set Up Your Task Manager'), 1),
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "decks-tm-sub" }, "Your own deck for tasks, including items sent from meetings and your rocks.", -1))
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("span", {
                      class: "decks-arrow",
                      "aria-hidden": "true"
                    }, "›", -1))
                  ], 2))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.currentFolder ? _ctx.currentFolder.Name : _ctx.boardFilter == 'all' ? 'All Decks' : 'My Decks'), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.boards.length) + " " + _toDisplayString(_ctx.boards.length == 1 ? 'deck' : 'decks'), 1)
        ]),
        (_ctx.boards.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boards, (board) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: board.Slug,
                  class: "decks-tile",
                  to: '/deck/' + board.Slug
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(board.Name), 1),
                        (board.IsTaskManager)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                              _cache[20] || (_cache[20] = _createTextVNode("Task Manager", -1)),
                              (board.OwnerName)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · " + _toDisplayString(board.OwnerName), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("span", {
                        class: "decks-arrow",
                        "aria-hidden": "true"
                      }, "›", -1))
                    ]),
                    _createElementVNode("div", {
                      class: "decks-strip",
                      role: "img",
                      "aria-label": _ctx.stripLabel(board)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((board.ColumnCounts || []).filter(c => c.count), (col) => {
                        return (_openBlock(), _createElementBlock("i", {
                          key: col.name,
                          style: _normalizeStyle({ flex: col.count, background: col.color })
                        }, null, 4))
                      }), 128))
                    ], 8, _hoisted_25),
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((board.ColumnCounts || []).slice(0, _ctx.LEGEND_MAX), (col) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: col.name,
                          title: col.name + ' ' + col.count
                        }, [
                          _createElementVNode("i", {
                            class: "decks-dot",
                            style: _normalizeStyle({ background: col.color })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(col.name), 1),
                          _createTextVNode(_toDisplayString(col.count), 1)
                        ], 8, _hoisted_27))
                      }), 128)),
                      ((board.ColumnCounts || []).length > _ctx.LEGEND_MAX)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "decks-legend-more",
                            title: board.ColumnCounts.slice(_ctx.LEGEND_MAX).map(c => c.name + ' ' + c.count).join('\n')
                          }, "+" + _toDisplayString(board.ColumnCounts.length - _ctx.LEGEND_MAX) + " more", 9, _hoisted_29))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(board.CardCount ? board.CardCount + (board.CardCount == 1 ? ' card' : ' cards') : 'No cards yet'), 1),
                      (board.Overdue)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(board.Overdue) + " overdue", 1))
                        : _createCommentVNode("", true),
                      ((board.Members || []).length)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "decks-avatars",
                            title: board.Members.join(', ')
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(board.Members.slice(0, 3), (name) => {
                              return (_openBlock(), _createElementBlock("span", { key: name }, _toDisplayString(_ctx.initials(name)), 1))
                            }), 128)),
                            (board.Members.length > 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, "+" + _toDisplayString(board.Members.length - 3), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_33))
                        : _createCommentVNode("", true),
                      (board.LastActivity)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "decks-updated",
                            title: new Date(board.LastActivity).toLocaleString()
                          }, _toDisplayString(_ctx.relativeTime(board.LastActivity)), 9, _hoisted_35))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]))
          : (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (_ctx.searchQ.length >= 3)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("No decks match that search.")
                    ], 64))
                  : (_ctx.currentFolder)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[22] || (_cache[22] = _createTextVNode("No decks in this folder yet. ", -1)),
                        _createElementVNode("a", {
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.editingFolder = _ctx.currentFolder), ["prevent"]))
                        }, "Add decks")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode("No decks yet. Add one to get started.")
                      ], 64))
              ]))
            : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.showAddBoard)
      ? (_openBlock(), _createBlock(_component_add_company_board, {
          key: 0,
          onClose: _cache[10] || (_cache[10] = () => { _ctx.showAddBoard = false; _ctx.getBoards(); })
        }))
      : _createCommentVNode("", true),
    (_ctx.editingFolder)
      ? (_openBlock(), _createBlock(_component_deck_folder_modal, {
          key: 1,
          boards: _ctx.folderBoards,
          folder: _ctx.editingFolder == 'new' ? null : _ctx.editingFolder,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editingFolder = null)),
          onSaved: _ctx.folderSaved,
          onDeleted: _ctx.folderDeleted
        }, null, 8, ["boards", "folder", "onSaved", "onDeleted"]))
      : _createCommentVNode("", true)
  ]))
}